module.exports = __webpack_public_path__ + "static/img/part2.2a2c31f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/part2.png
// module id = i3nP
// module chunks = 0